// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartPartType } from './part-part-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
        RawGood: 1,
        InProcess: 2,
        Invenotry: 3,
        Finished: 4,
        Option: 5,
        Replacement: 6,
        Trailer: 7,
        NonTaxable: 9,
    };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder!: number;
  name?: string;
  note?: string;
  partPartTypes!: PartPartType[];
}

